import { useTranslation } from "react-i18next";

import { Header } from "@pentabd/ui";
import { IconShoppingCart01 } from "@pentabd/icons";

import { ROUTES } from "@constants/routes";
import { SingleDemandResponseType } from "@type/procurements/demand";

const CreateProcurementDemandPageHeader = ({
  demand,
  id,
}: {
  demand: SingleDemandResponseType | null;
  id: string | undefined;
}) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconShoppingCart01 fill="dark" size="20" />,
    },
    {
      label: t("SIDEBAR.PROCUREMENT.PROCUREMENT_DEMAND"),
      link: ROUTES.PROCUREMENT.DEMANDS,
    },
    {
      label: id
        ? demand?.name
        : t("SIDEBAR.PROCUREMENT.NEW_PROCUREMENT_DEMAND"),
    },
  ];

  const headerText = {
    header: id ? demand?.name : t("PROCUREMENT_DEMAND.DEMAND_CREATE.HEADING"),
    subHeader: id
      ? (demand?.demandRefNo as string)
      : t("PROCUREMENT_DEMAND.DEMAND_CREATE.DESCRIPTION"),
  };

  return (
    <Header
      headerText={headerText}
      breadcrumbs={breadcrumbs}
      // actions={[
      //   <Button fill="fill" type="primary" size="xs">
      //     {t("PROCUREMENT_DEMAND.DEMAND_CREATE.ACCESS")}
      //   </Button>,
      // ]}
    />
  );
};

export default CreateProcurementDemandPageHeader;
